module.exports = __webpack_public_path__ + "static/media/ETH.407ef56e.png";